import {createSlice} from '@reduxjs/toolkit';

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    isLoading: false,
    analyticsList:[],
    paginatedAnalytics:{},
    error:"",
    navigatedFromToLogin: "",
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAnalyticsList: (state, action) => {
      state.analyticsList = action.payload;
    },
    setPaginatedAnalyticsList: (state, action) => {
      state.paginatedAnalytics = action.payload;
    },
    setNavigatedFromToLogin: (state, action) => {
      state.navigatedFromToLogin = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setAnalyticsList,
  setPaginatedAnalyticsList,
  setNavigatedFromToLogin
} = analyticsSlice.actions;

export default analyticsSlice.reducer;
